import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoJcb24 = t0 => {
  const $ = _c(14);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M21.1668 16.6067C21.1668 18.1756 19.8893 19.4531 18.3205 19.4531H2.8335V8.17969C2.8335 6.61082 4.111 5.33331 5.67987 5.33331H21.1668V16.6067Z" fill="#fff" />;
    t2 = <path d="M17.166 6.28589C16.0453 6.28589 15.1264 7.19359 15.1264 8.32542V10.4434H18.0064C18.0737 10.4434 18.1521 10.4434 18.2081 10.4546C18.8581 10.4882 19.34 10.8244 19.34 11.4071C19.34 11.8666 19.015 12.2588 18.4099 12.3372V12.3596C19.071 12.4045 19.5753 12.7743 19.5753 13.3458C19.5753 13.9621 19.015 14.3656 18.2754 14.3656H15.1152V18.5118H18.1073C19.2279 18.5118 20.1468 17.6041 20.1468 16.4723V6.28589H17.166Z" fill="url(#a)" />;
    t3 = <path d="M16.1238 13.7156H17.3004C17.3173 13.7156 17.3453 13.7128 17.3733 13.71C17.4013 13.7072 17.4293 13.7044 17.4461 13.7044C17.6702 13.6596 17.8608 13.4578 17.8608 13.1777C17.8608 12.9087 17.6702 12.707 17.4461 12.651C17.4125 12.6398 17.3453 12.6398 17.3004 12.6398H16.1238V13.7156Z" fill="url(#b)" />;
    t4 = <path d="M17.3004 11.0597C17.5246 11.0933 17.7151 11.2726 17.7151 11.5416C17.7151 11.8105 17.5246 11.9898 17.3004 12.0235C17.2892 12.0347 17.222 12.0347 17.1884 12.0347H16.1238V11.0485H17.1884C17.2069 11.0485 17.2322 11.0519 17.2549 11.055C17.2735 11.0575 17.2904 11.0597 17.3004 11.0597Z" fill="url(#c)" />;
    t5 = <path d="M5.89302 6.28583C4.7724 6.28583 3.85349 7.19353 3.85349 8.32535V13.3569C4.42501 13.6371 5.01894 13.8164 5.61286 13.8164C6.31885 13.8164 6.69987 13.3906 6.69987 12.8078V10.4321H8.44803V12.7966C8.44803 13.7155 7.87651 14.4663 5.93784 14.4663C4.76119 14.4663 3.84229 14.2086 3.84229 14.2086V18.5006H6.83434C7.95496 18.5006 8.87387 17.5929 8.87387 16.4611V6.28583H5.89302Z" fill="url(#d)" />;
    t6 = <path d="M11.5298 6.28577C10.4091 6.28577 9.49023 7.19347 9.49023 8.32529V10.9924C10.0057 10.5553 10.9022 10.2752 12.3478 10.3424C13.121 10.376 13.9503 10.5889 13.9503 10.5889V11.4518C13.5357 11.2389 13.0426 11.0484 12.4038 11.0036C11.3056 10.9251 10.6445 11.463 10.6445 12.4043C10.6445 13.3569 11.3056 13.8948 12.4038 13.8051C13.0426 13.7603 13.5357 13.5586 13.9503 13.3569V14.2198C13.9503 14.2198 13.1322 14.4327 12.3478 14.4663C10.9022 14.5335 10.0057 14.2534 9.49023 13.8163V18.5229H12.4823C13.6029 18.5229 14.5218 17.6152 14.5218 16.4834V6.28577H11.5298Z" fill="url(#e)" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <linearGradient id="a" x1={15.124} y1={11.54} x2={20.16} y2={11.54} gradientUnits="userSpaceOnUse"><stop stopColor="#007940" /><stop offset={0.229} stopColor="#00873F" /><stop offset={0.743} stopColor="#40A737" /><stop offset={1} stopColor="#5CB531" /></linearGradient>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <linearGradient id="b" x1={15.124} y1={11.54} x2={20.16} y2={11.54} gradientUnits="userSpaceOnUse"><stop stopColor="#007940" /><stop offset={0.229} stopColor="#00873F" /><stop offset={0.743} stopColor="#40A737" /><stop offset={1} stopColor="#5CB531" /></linearGradient>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <linearGradient id="c" x1={15.124} y1={11.54} x2={20.16} y2={11.54} gradientUnits="userSpaceOnUse"><stop stopColor="#007940" /><stop offset={0.229} stopColor="#00873F" /><stop offset={0.743} stopColor="#40A737" /><stop offset={1} stopColor="#5CB531" /></linearGradient>;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <linearGradient id="d" x1={3.851} y1={12.394} x2={8.965} y2={12.394} gradientUnits="userSpaceOnUse"><stop stopColor="#1F286F" /><stop offset={0.475} stopColor="#004E94" /><stop offset={0.826} stopColor="#0066B1" /><stop offset={1} stopColor="#006FBC" /></linearGradient>;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <defs>{t7}{t8}{t9}{t10}<linearGradient id="e" x1={9.461} y1={12.394} x2={14.428} y2={12.394} gradientUnits="userSpaceOnUse"><stop stopColor="#6C2C2F" /><stop offset={0.173} stopColor="#882730" /><stop offset={0.573} stopColor="#BE1833" /><stop offset={0.859} stopColor="#DC0436" /><stop offset={1} stopColor="#E60039" /></linearGradient></defs>;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== ariaLabel || $[12] !== className) {
    t12 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}{t2}{t3}{t4}{t5}{t6}{t11}</svg>;
    $[11] = ariaLabel;
    $[12] = className;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  return t12;
};
export default IcoJcb24;